import { monthInWords } from '~/lib/utils/datetime_utility';
import { PRESET_TYPES } from '../../constants';
import CommonMixin from '../../mixins/common_mixin';
export default {
    name: 'QuartersHeaderSubItem',
    mixins: [
        CommonMixin
    ],
    props: {
        currentDate: {
            type: Date,
            required: true
        },
        timeframeItem: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            // eslint-disable-next-line vue/no-unused-properties -- `presetType` used by the `CommonMixin` mixin
            presetType: PRESET_TYPES.QUARTERS,
            indicatorStyle: {}
        };
    },
    computed: {
        headerSubItems () {
            return this.timeframeItem.range;
        }
    },
    mounted () {
        this.$nextTick(()=>{
            this.indicatorStyle = this.getIndicatorStyles();
        });
    },
    methods: {
        getSubItemValueClass (subItem) {
            let itemValueClass = '';
            if (this.currentDate.getFullYear() === subItem.getFullYear() && this.currentDate.getMonth() === subItem.getMonth()) {
                itemValueClass = 'label-dark label-bold';
            } else if (this.currentDate < subItem) {
                itemValueClass = 'label-dark';
            }
            return itemValueClass;
        },
        getSubItemValue (subItem) {
            return monthInWords(subItem, true);
        }
    }
};
